import { Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;

  handleClose(): void;
}

const StartImmediatelySuccessDialog: React.FC<Props> = ({ open, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogContent className={classes.content}>
        <Typography className={classes.text}>
          <Trans i18nKey={'campaignStartingSoon'}>
            We are going to start your campaign in the following minutes. <span className={classes.highlight}>Stay alert!</span> In the next few
            minutes, we&apos;ll generate messages for your approval before sending them out.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('ok')} size={'lg'} underline={'always'} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  content: {
    padding: '32px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  highlight: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default StartImmediatelySuccessDialog;
